import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CalendarOutlined } from "@ant-design/icons";
import WorkflowFlow from "./WorkflowFlow";
import erpMiniHeroBg from "~/assets/logo/ERP_Mini.png";
import "../style.css";

const HeroSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("erpMini");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const titleParts = useMemo(() => {
    const raw = String(t("hero.title") ?? "").trim();
    if (!raw) return { amber: "", rest: "" };
    const parts = raw.split(" ").filter(Boolean);
    if (parts.length === 1) return { amber: parts[0], rest: "" };
    return { amber: parts.slice(0, -1).join(" "), rest: parts[parts.length - 1] };
  }, [t]);

  return (
    <section className="dev-hero-section dev-erpMini-hero">
      <div className="dev-hero-dotgrid" />
      <div className="dev-hero-glow dev-hero-glow-1" />
      <div className="dev-hero-glow dev-hero-glow-2" />

      <div className="dev-hero-inner dev-erpMini-hero-inner">
        <div className={`dev-erpMini-hero-overlay${mounted ? " dev-hero-visible" : ""}`}>
          <div className="dev-erpMini-hero-overlay-media" aria-hidden>
            <img src={erpMiniHeroBg} alt={t("hero.image_alt") as string} />
            <div className="dev-erpMini-hero-overlay-scrim" />
          </div>

          <div className="dev-erpMini-hero-overlay-content">
            <div className="dev-hero-badge">
              <span className="dev-hero-badge-dot" />
              {t("hero.badge")}
            </div>

            <h1 className="dev-hero-title dev-erpMini-hero-title">
              {titleParts.amber && <span className="dev-hero-title-amber">{titleParts.amber}</span>}
              {titleParts.amber && titleParts.rest ? " " : null}
              {titleParts.rest && <span className="dev-hero-title-text">{titleParts.rest}</span>}
            </h1>

            <p className="dev-hero-subtitle">{t("hero.subtitle")}</p>

            <div className="dev-erpMini-hero-cta">
              <button
                type="button"
                className="dev-cta-primary dev-erpMini-hero-cta-btn"
                onClick={() => navigate("/contact")}
              >
                <CalendarOutlined />
                {t("cta.button")}
              </button>
            </div>

            <div className="dev-erpMini-tagline-box dev-erpMini-tagline-box--accent dev-erpMini-tagline-box--overlay">
              <div className="dev-erpMini-tagline-title">{t("hero.tagline_title")}</div>
              <div className="dev-erpMini-tagline-desc">{t("hero.tagline_desc")}</div>
              <WorkflowFlow variant="compact" className="dev-erpMini-tagline-flow" />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
